import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import * as style from './style.css';
import { HubBlock } from '../HubBlock/HubBlock';
import { TCompareHubCategory } from '../../containers/CompareHubPage/tracking';
import { useSelector } from 'react-redux';
import { selectComparisonAlbums } from '../../selectors/comparisonAlbums';

export interface ICompareHubPageProps {
  onClick(label: TCompareHubCategory): void;
}

export const CompareHubPage = ({ onClick }: ICompareHubPageProps) => {
  const albums = useSelector(selectComparisonAlbums);

  return (
    <main className={style['container']} data-testid="compare-hub_page">
      <UIHeading1 as="h1">Сравнение</UIHeading1>
      <nav className={style['links']}>
        {albums.map(album => (
          <HubBlock
            key={album.title}
            type={album.propertyType}
            title={album.title}
            subtitle={album.subtitle}
            images={album.images}
            onClick={onClick}
          />
        ))}
      </nav>
    </main>
  );
};
